import { z } from 'zod';

export class SchoolSetting {
  public id: string;
  public schoolId: string;
  public isUnderMaintenance: boolean;
  public shouldUseUXUIRevampV1: boolean;
  public shouldUseUXUIRevampV2: boolean;
  public shouldUseCheatDetection: boolean;
  public shouldUseGamification: boolean;
  public canListenBeforeSubmit: boolean;
  public bypassOpenAnswerWordCountThreshold: boolean;
  public shouldShowOtherStudentNamesOnLeaderboard: boolean;
  public shouldUseUserAIVoiceSelector: boolean;
  public shouldUseTwoWayVoiceModel: boolean;
  public shouldUseListeningToUserResponseOnError: boolean;
  public shouldUseLiveSession: boolean;
  public shouldUseTranscriptionEditor: boolean;
  public createdAt: Date;
  public updatedAt: Date;

  constructor(json: unknown) {
    const validatedJson = SchoolSetting.zodSchema.parse(json);
    this.id = validatedJson.id;
    this.schoolId = validatedJson.schoolId;
    this.isUnderMaintenance = validatedJson.isUnderMaintenance;
    this.shouldUseUXUIRevampV1 = validatedJson.shouldUseUXUIRevampV1;
    this.shouldUseUXUIRevampV2 = validatedJson.shouldUseUXUIRevampV2;
    this.shouldUseCheatDetection = validatedJson.shouldUseCheatDetection;
    this.shouldUseGamification = validatedJson.shouldUseGamification;
    this.canListenBeforeSubmit = validatedJson.canListenBeforeSubmit;
    this.bypassOpenAnswerWordCountThreshold = validatedJson.bypassOpenAnswerWordCountThreshold;
    this.shouldShowOtherStudentNamesOnLeaderboard = validatedJson.shouldShowOtherStudentNamesOnLeaderboard;
    this.shouldUseUserAIVoiceSelector = validatedJson.shouldUseUserAIVoiceSelector;
    this.shouldUseTwoWayVoiceModel = validatedJson.shouldUseTwoWayVoiceModel;
    this.shouldUseListeningToUserResponseOnError = validatedJson.shouldUseListeningToUserResponseOnError;
    this.shouldUseLiveSession = validatedJson.shouldUseLiveSession;
    this.shouldUseTranscriptionEditor = validatedJson.shouldUseTranscriptionEditor;
    this.createdAt = validatedJson.createdAt;
    this.updatedAt = validatedJson.updatedAt;
  }

  public static zodSchema = z.object({
    id: z.string().uuid(),
    schoolId: z.string().uuid(),
    isUnderMaintenance: z.boolean(),
    shouldUseUXUIRevampV1: z.boolean(),
    shouldUseUXUIRevampV2: z.boolean(),
    shouldUseCheatDetection: z.boolean(),
    shouldUseGamification: z.boolean(),
    canListenBeforeSubmit: z.boolean(),
    bypassOpenAnswerWordCountThreshold: z.boolean(),
    shouldShowOtherStudentNamesOnLeaderboard: z.boolean(),
    shouldUseUserAIVoiceSelector: z.boolean().default(false),
    shouldUseTwoWayVoiceModel: z.boolean().default(false),
    shouldUseListeningToUserResponseOnError: z.boolean().default(false),
    shouldUseLiveSession: z.boolean().default(false),
    shouldUseTranscriptionEditor: z.boolean().default(false),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
  });

  public static fromJson(json: unknown): SchoolSetting {
    return new SchoolSetting(json);
  }
}
